import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { DayplannerKeys } from "modules/Dayplanner/queryKeys";
import { ApiInstance } from "utils/Api";

type UnassignMutationPayload = {
  appointment_id: number;
};

export const useUnassignMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  const mutation = useMutation({
    mutationFn: async (data: UnassignMutationPayload) => ApiInstance.post("/dayplanner/appointments/unassign", data),
    onMutate: data => {
      if (!selectedLocation?.id) throw new Error("invalid location");

      const appointments = typedQueryClient.getQueryData(DayplannerKeys.appointments);
      if (!appointments) return [];

      const appointment = appointments.find(app => app.id === data.appointment_id);
      if (!appointment) return appointments;

      const updatedAppointments = appointments.map(app => {
        if (app.id === appointment.id) return { ...app, assigned_mechanic: null, assigned_mechanic_order: null, last_assigned_mechanic: app.assigned_mechanic };

        if (
          app.assigned_mechanic === appointment.assigned_mechanic &&
          app.assigned_mechanic_order &&
          appointment.assigned_mechanic_order &&
          app.assigned_mechanic_order > appointment.assigned_mechanic_order
        ) {
          return { ...app, assigned_mechanic_order: app.assigned_mechanic_order - 1 };
        }

        return app;
      });

      typedQueryClient.setQueryData(DayplannerKeys.appointments, updatedAppointments);

      return appointments;
    },
    onError: (error, _, appointments) => {
      toast.error(error.message);
      if (selectedLocation?.id) typedQueryClient.setQueryData(DayplannerKeys.appointments, appointments ?? []);
    }
  });

  return mutation.mutate;
};
